'use strict';

/**
 * Dependencies
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var base64url = require('base64url');

var _require = require('@trust/json-document'),
    JSONDocument = _require.JSONDocument;

var JWTSchema = require('../schemas/JWTSchema');

var _require2 = require('@trust/jwa'),
    JWA = _require2.JWA;

var DataError = require('../errors/DataError');
var KeyManagement = require('../KeyManagement');

var keyManagement = new KeyManagement();

/**
 * Helper Functions
 * @ignore
 */
function clean(input) {
  return JSON.parse(JSON.stringify(input));
}

/**
 * JWT
 */

var JWT = function (_JSONDocument) {
  _inherits(JWT, _JSONDocument);

  /**
   * constructor
   */
  function JWT(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, JWT);

    options.filter = options.filter || false;

    var _this = _possibleConstructorReturn(this, (JWT.__proto__ || Object.getPrototypeOf(JWT)).call(this, data, options));

    var plaintext = data.plaintext,
        type = data.type,
        serialization = data.serialization;


    Object.defineProperty(_this, 'plaintext', {
      value: plaintext,
      configurable: true,
      enumerable: false
    });
    Object.defineProperty(_this, 'type', {
      value: type,
      configurable: true,
      enumerable: false
    });
    Object.defineProperty(_this, 'serialization', {
      value: serialization,
      configurable: true,
      enumerable: false
    });
    return _this;
  }

  /**
   * schema
   */


  _createClass(JWT, [{
    key: 'isJWE',


    /**
     * isJWE
     *
     * @todo
     */
    value: function isJWE() {
      // check if type is set to JWE
      // check if ciphertext member exists
      // check jose header for alg, enc field
      // TODO: check alg, check for enc in all headers
      return this.type === 'JWE' || this.ciphertext !== undefined || this.header !== undefined && this.header.enc !== undefined;
    }

    /**
     * resolveKeys
     *
     * @todo  This needs to be updated for use with the new API
     */
    // resolveKeys (jwks) {
    //   let kid = this.header.kid

    //   let keys, match

    //   // treat an array as the "keys" property of a JWK Set
    //   if (Array.isArray(jwks)) {
    //     keys = jwks
    //   }

    //   // presence of keys indicates object is a JWK Set
    //   if (jwks.keys) {
    //     keys = jwks.keys
    //   }

    //   // wrap a plain object they is not a JWK Set in Array
    //   if (!jwks.keys && typeof jwks === 'object') {
    //     keys = [jwks]
    //   }

    //   // ensure there are keys to search
    //   if (!keys) {
    //     throw new DataError('Invalid JWK argument')
    //   }

    //   // match by "kid" or "use" header
    //   if (kid) {
    //     match = keys.find(jwk => jwk.kid === kid)
    //   } else {
    //     match = keys.find(jwk => jwk.use === 'sig')
    //   }

    //   // assign matching key to JWT and return a boolean
    //   if (match) {
    //     console.log(match)
    //     this.key = match.cryptoKey
    //     return true
    //   } else {
    //     return false
    //   }
    // }

    /**
     * encode
     *
     * @description
     * Encode a JSON Web Token instance
     *
     * @param {...Object} data
     * @returns {Promise<SerializedToken>}
     */

  }, {
    key: 'encode',
    value: function encode() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));

      if (this.isJWE()) {
        return this.encrypt(params);
      } else {
        return this.sign(params);
      }
    }

    /**
     * sign
     *
     * @description
     * Sign a JWT instance
     *
     * @todo import different types of key
     *
     * @param {...Object} data
     * @returns {Promise<SerializedToken>}
     */

  }, {
    key: 'sign',
    value: function sign() {
      var _this2 = this;

      for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        data[_key2] = arguments[_key2];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));

      var payload = this.payload;
      var protectedHeader = params.protected,
          unprotectedHeader = params.header,
          signature = params.signature,
          signatures = params.signatures,
          serialization = params.serialization,
          cryptoKey = params.cryptoKey,
          _params$validate = params.validate,
          validate = _params$validate === undefined ? true : _params$validate,
          result = params.result;


      if (validate) {
        var validation = this.validate();

        if (!validation.valid) {
          return Promise.reject(validation);
        }
      }

      // Override serialization
      if (serialization) {
        Object.defineProperty(this, 'serialization', {
          value: serialization,
          enumerable: false,
          configurable: true
        });
      }

      // Normalize new flat signature
      if (cryptoKey && !signature && (unprotectedHeader || protectedHeader)) {
        var descriptor = {};

        if (!protectedHeader && unprotectedHeader) {
          descriptor.protected = unprotectedHeader;
        } else {
          descriptor.protected = protectedHeader;
          descriptor.header = unprotectedHeader;
        }

        descriptor.cryptoKey = cryptoKey;

        // Add to signatures array
        if (signatures && Array.isArray(signatures)) {
          signatures.push(descriptor);
        } else {
          signatures = [descriptor];
        }
      }

      // Create signatures
      var promises = [];
      if (signatures && Array.isArray(signatures)) {
        // Ignore ambiguous/invalid descriptors
        promises = signatures.filter(function (descriptor) {
          return descriptor.cryptoKey && !descriptor.signature;

          // assemble and sign
        }).map(function (descriptor) {
          var protectedHeader = descriptor.protected,
              unprotectedHeader = descriptor.header,
              signature = descriptor.signature,
              cryptoKey = descriptor.cryptoKey;
          var alg = protectedHeader.alg;

          // Encode signature content

          var encodedHeader = base64url(JSON.stringify(protectedHeader));
          var encodedPayload = base64url(JSON.stringify(payload));
          var data = encodedHeader + '.' + encodedPayload;

          return JWA.sign(alg, cryptoKey, data).then(function (signature) {
            return {
              protected: protectedHeader,
              header: unprotectedHeader,
              signature: signature
            };
          });
        });
      }

      // Await signatures
      return Promise.all(promises).then(function (signatures) {
        if (signatures.length > 0) {
          if (_this2.signatures && Array.isArray(_this2.signatures)) {
            _this2.signatures = _this2.signatures.concat(signatures);
          } else {
            _this2.signatures = signatures;
          }
        }

        if (!result || result === 'string') {
          return _this2.serialize();
        } else if (result === 'object' || result === 'instance') {
          return _this2;
        }
      });
    }

    /**
     * verify
     *
     * @description
     * Verify a decoded JSON Web Token instance
     *
     * @todo jwk, jwkSet and pem key types
     *
     * @param {...Object} data
     * @returns {Promise<Boolean|Object>}
     */

  }, {
    key: 'verify',
    value: function verify() {
      var _this3 = this;

      for (var _len3 = arguments.length, data = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        data[_key3] = arguments[_key3];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));
      var signatures = this.signatures,
          payload = this.payload,
          serialization = this.serialization;
      var validate = params.validate,
          result = params.result,
          cryptoKey = params.cryptoKey,
          cryptoKeys = params.cryptoKeys;

      // Validate instance

      if (validate) {
        var validation = this.validate();

        if (!validation.valid) {
          throw new Error(validation);
        }
      }

      // Encode payload
      var encodedPayload = base64url(JSON.stringify(payload));

      // Verify all signatures with a key present
      var promises = signatures.map(function (descriptor, index) {

        var key = void 0;
        // Get manually mapped key
        if (descriptor.cryptoKey) {
          key = descriptor.cryptoKey;

          // Get corresponding key
        } else if (cryptoKeys && Array.isArray(cryptoKeys) && index < cryptoKeys.length && cryptoKeys[index]) {

          key = cryptoKeys[index];

          // Attempt to use the single key
        } else if (cryptoKey) {
          key = cryptoKey;

          // No key to verify signature; ignore
        } else {
          return Promise.resolve(true);
        }

        var protectedHeader = descriptor.protected,
            unprotectedHeader = descriptor.header,
            signature = descriptor.signature;

        // no signature to verify

        if (!signature) {
          return Promise.reject(new DataError('Missing signature(s)'));
        }

        var alg = protectedHeader.alg;

        // Encode header and assemble signature verification data

        var encodedHeader = base64url(JSON.stringify(protectedHeader));
        var data = encodedHeader + '.' + encodedPayload;

        // Verify signature and store result on the descriptor
        return JWA.verify(alg, key, signature, data).then(function (verified) {
          Object.defineProperty(signatures[index], 'verified', {
            value: verified,
            enumerable: false,
            configurable: true
          });
          return verified;
        });
      });

      // Await verification results
      return Promise.all(promises).then(function (verified) {
        verified = verified.reduce(function (prev, val) {
          return prev ? val : false;
        }, true);

        Object.defineProperty(_this3, 'verified', {
          value: verified,
          enumerable: false,
          configurable: true
        });

        if (!result || result === 'boolean') {
          return verified;
        } else if (result === 'object' || result === 'instance') {
          return _this3;
        }
      });
    }

    /**
     * encrypt
     *
     * @description
     * Encrypt the given data and create a JSON Web Encryption instance
     *
     * @param {...Object} data
     * @returns {Promise<SerializedToken>}
     */

  }, {
    key: 'encrypt',
    value: function encrypt() {
      var _this4 = this;

      for (var _len4 = arguments.length, data = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        data[_key4] = arguments[_key4];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));

      var key = params.key;
      var protectedHeader = this.protected,
          unprotectedHeader = this.unprotected,
          plaintext = this.plaintext,
          aad = this.aad,
          tag = this.tag,
          recipients = this.recipients;


      var alg = void 0,
          cek = void 0,
          encrypted_key = void 0;
      if (recipients.length > 0) {
        recipients.map(function (recipient) {
          alg = recipient.header.alg || protectedHeader.alg;
          var result = keyManagement.determineCek(false, alg, key);
          recipient.encrypted_key = result.encrypted_key;
        });
        // do the steps for each recipient
      } else {
        alg = protectedHeader.alg;
        var result = keyManagement.determineCek(false, alg, key);
        cek = result.cek;
        encrypted_key = base64url(result.encrypted_key);
        this.recipients.push({ encrypted_key: encrypted_key });
      }

      // iv is generated and encoded in the specific class

      // check and apply compression algorithm
      if (protectedHeader.zip) {
        // JWA.compress()
      }

      if (!protectedHeader) {
        protectedHeader = "";
      }
      var encodedHeader = base64url(JSON.stringify(protectedHeader));
      if (aad) {
        var encodedAad = base64url(aad);
        aad = encodedHeader + '.' + encodedAad;
      } else {
        aad = encodedHeader;
      }

      return Promise.resolve(JWA.encrypt(protectedHeader.enc, cek, plaintext, aad).then(function (_ref) {
        var iv = _ref.iv,
            ciphertext = _ref.ciphertext,
            tag = _ref.tag;

        _this4.iv = iv;
        _this4.ciphertext = ciphertext;
        _this4.tag = tag;
      }).then(function () {
        return _this4.serialize();
      }));
    }

    /**
     * decrypt
     *
     * @description
     * Decrypt the contents of a JSON Web Token instance
     *
     * @param {...Object} data
     * @returns {Promise<Object>}
     */

  }, {
    key: 'decrypt',
    value: function decrypt() {
      for (var _len5 = arguments.length, data = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        data[_key5] = arguments[_key5];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));

      var protectedHeader = this.protected,
          unprotected = this.unprotected,
          iv = this.iv,
          _aad = this.aad,
          aad = _aad === undefined ? "" : _aad,
          ciphertext = this.ciphertext,
          tag = this.tag,
          recipients = this.recipients,
          serialization = this.serialization;
      var key = params.key;


      aad = base64url.decode(aad);

      if (!protectedHeader) {
        protectedHeader = "";
      }
      var encodedHeader = base64url(JSON.stringify(protectedHeader));
      if (aad) {
        var encodedAad = base64url(aad);
        aad = encodedHeader + '.' + encodedAad;
      } else {
        aad = encodedHeader;
      }

      var decryptionSucceeded = false;

      var promises = recipients.map(function (recipient) {
        var encrypted_key = recipient.encrypted_key;
        encrypted_key = base64url.decode(encrypted_key);

        var joseHeader = void 0;
        if (serialization === 'compact') {
          joseHeader = Object.assign({}, protectedHeader);
        } else {
          var recipientHeader = void 0;
          // the protected header was verified in from method
          try {
            if (unprotected) {
              unprotected = JSON.parse(unprotected);
            }
            if (recipient.header) {
              recipientHeader = JSON.parse(recipient.header);
            }
            joseHeader = Object.assign({}, protectedHeader, unprotected, recipientHeader);
            // the same Header Parameter name also
            // MUST NOT occur in distinct JSON object
            // values that together comprise the JOSE Header
            var protectedKeys = protectedHeader ? new Set(Object.keys(protectedHeader)) : [];
            var unprotectedKeys = unprotected ? new Set(Object.keys(unprotected)) : [];
            var recipientKeys = recipientHeader ? new Set(Object.keys(recipientHeader)) : [];
            var intersection = void 0;
            intersection = new Set([].concat(_toConsumableArray(unprotectedKeys)).filter(function (x) {
              return protectedKeys.has(x);
            }));
            if (intersection.size !== 0) {
              throw new Error('Duplicated header parameters');
            }
            intersection = new Set([].concat(_toConsumableArray(unprotectedKeys)).filter(function (x) {
              return recipient.has(x);
            }));
            if (intersection.size !== 0) {
              throw new Error('Duplicated header parameters');
            }
            intersection = new Set([].concat(_toConsumableArray(recipientKeys)).filter(function (x) {
              return protectedKeys.has(x);
            }));
            if (intersection.size !== 0) {
              throw new Error('Duplicated header parameters');
            }
          } catch (err) {
            throw new DataError('Header is not a valid object');
          }
        }
        // verify fields - schemas
        // 6. determine the kmm
        // 7. verify the key ? what does this mean ?
        var alg = recipient.header && recipient.header.alg || protectedHeader.alg;
        try {
          if (alg === 'dir' && encrypted_key.length !== 0) {
            throw new DataError("JWE encrypted key is not empty for a direct encryption");
          }

          var _keyManagement$determ = keyManagement.determineCek(true, alg, key),
              cek = _keyManagement$determ.cek;

          Object.defineProperty(recipient, 'cekDetermined', {
            value: true,
            enumerable: false,
            configurable: true
          });
          return JWA.decrypt(protectedHeader.enc, cek, ciphertext, iv, tag, aad).then(function (result) {
            if (joseHeader.zip) {
              // JWA.decompress()
            }
            Object.defineProperty(recipient, 'decrptedSuccessfully', {
              value: true,
              enumerable: true,
              configurable: true
            });
            decryptionSucceeded = true;
            Object.defineProperty(recipient, 'result', {
              value: result,
              enumerable: true,
              configurable: true
            });
            return recipient;
          });
        } catch (err) {}
      });

      // Await verification results
      return Promise.all(promises).then(function () {
        if (!decryptionSucceeded) {
          return Promise.reject("Decryption failed for all recipients");
        }
        if (serialization === 'json') {
          return recipients;
        } else {
          return recipients[0].result;
        }
      });
    }

    /**
     * toCompact
     */

  }, {
    key: 'toCompact',
    value: function toCompact() {
      if (!this.isJWE()) {
        var payload = this.payload,
            signatures = this.signatures;

        var protectedHeader = void 0,
            signature = void 0;

        // Signatures present
        if (signatures && Array.isArray(signatures) && signatures.length > 0) {
          protectedHeader = signatures[0].protected;
          signature = signatures[0].signature;
        }

        if (!protectedHeader) {
          throw new DataError('Protected header is required');
        }

        // Encode protected header and payload
        var encodedPayload = base64url(JSON.stringify(payload));
        var encodedHeader = base64url(JSON.stringify(protectedHeader));
        var _data = encodedHeader + '.' + encodedPayload;

        // Return compact JWT with signature
        if (signature) {
          return _data + '.' + signature;

          // Return compact JWT without signature
        } else {
          return _data + '.';
        }
      } else {
        var _protectedHeader = this.protected,
            iv = this.iv,
            aad = this.aad,
            ciphertext = this.ciphertext,
            tag = this.tag;


        if (!_protectedHeader) {
          throw new DataError('Protected header is required');
        }

        // Encode protected header
        // Key, iv, ciphertext, tag are already stored in base64url format
        var _encodedHeader = base64url(JSON.stringify(_protectedHeader));
        var key = this.recipients[0].encrypted_key;

        var _data2 = _encodedHeader + '.' + key + '.' + iv + '.' + ciphertext;

        // Return compact JWT
        if (tag) {
          return _encodedHeader + '.' + key + '.' + iv + '.' + ciphertext + '.' + tag;
        } else {
          return _data2 + '.';
        }
      }
    }

    /**
     * toFlattened
     */

  }, {
    key: 'toFlattened',
    value: function toFlattened() {

      if (!this.isJWE()) {
        var payload = this.payload,
            signatures = this.signatures;

        var protectedHeader = void 0,
            unprotectedHeader = void 0,
            signature = void 0;

        // Signatures present
        if (signatures && Array.isArray(signatures) && signatures.length > 0) {
          protectedHeader = signatures[0].protected;
          unprotectedHeader = signatures[0].header;
          signature = signatures[0].signature;
        }

        if (!protectedHeader) {
          throw new DataError('Protected header is required');
        }

        // Encode protected header and payload
        var encodedPayload = base64url(JSON.stringify(payload));
        var encodedHeader = base64url(JSON.stringify(protectedHeader));

        return JSON.stringify({
          payload: encodedPayload,
          header: unprotectedHeader,
          protected: encodedHeader,
          signature: signature
        });
      } else {
        var _protectedHeader2 = this.protected,
            unprotected = this.unprotected,
            iv = this.iv,
            aad = this.aad,
            ciphertext = this.ciphertext,
            tag = this.tag;


        if (!_protectedHeader2) {
          throw new DataError('Protected header is required');
        }
        // Encode protected header and payload
        var _encodedHeader2 = base64url(JSON.stringify(_protectedHeader2));

        var header = this.recipients[0].header;
        var encrypted_key = this.recipients[0].encrypted_key;

        return JSON.stringify({
          protected: _encodedHeader2,
          unprotected: unprotected,
          header: header,
          encrypted_key: encrypted_key,
          aad: aad,
          iv: iv,
          ciphertext: ciphertext,
          tag: tag
        });
      }
    }

    /**
     * toGeneral
     */

  }, {
    key: 'toGeneral',
    value: function toGeneral() {

      if (this.isJWE()) {
        var protectedHeader = this.protected,
            unprotected = this.unprotected,
            iv = this.iv,
            aad = this.aad,
            ciphertext = this.ciphertext,
            tag = this.tag,
            recipients = this.recipients;


        if (!protectedHeader) {
          protectedHeader = "";
        }
        // Encode protected header and payload
        var encodedHeader = base64url(JSON.stringify(protectedHeader));

        // Serialize recipient info
        var serializedRecipients = recipients.map(function (descriptor) {
          return JSON.stringify(descriptor);
        });

        return JSON.stringify({
          protected: encodedHeader,
          unprotected: unprotected,
          recipients: recipients,
          aad: aad,
          iv: iv,
          ciphertext: ciphertext,
          tag: tag
        });
      } else {
        var payload = this.payload,
            signatures = this.signatures;

        // Encode payload

        var encodedPayload = base64url(JSON.stringify(payload));

        // Return with signature
        if (signatures) {

          // Serialize signatures
          var serializedSignatures = signatures.map(function (descriptor) {
            var unprotectedHeader = descriptor.header,
                protectedHeader = descriptor.protected,
                signature = descriptor.signature;

            // Encode protected header

            var encodedHeader = base64url(JSON.stringify(protectedHeader));

            return {
              header: unprotectedHeader,
              protected: encodedHeader,
              signature: signature
            };
          });

          return JSON.stringify({
            payload: encodedPayload,
            signatures: serializedSignatures
          });

          // Return without signatures
        } else {
          return JSON.stringify({ payload: encodedPayload });
        }
      }
    }

    /**
     * toJWD
     *
     * @description
     * Convert a JWT to a JWD
     *
     * @return {JWD}
     */

  }, {
    key: 'toJWD',
    value: function toJWD() {
      var JWD = require('./JWD');
      return new JWD(this);
    }

    /**
     * serialize
     *
     * @description
     * Serialize a JWT instance to the preferred serialization
     *
     * @return {SerializedToken}
     */

  }, {
    key: 'serialize',
    value: function serialize() {
      var serialization = this.serialization;


      switch (serialization) {
        case 'compact':
          return this.toCompact();
        case 'flattened':
          return this.toFlattened();
        case 'json':
          return this.toGeneral();
        case 'document':
          return this.toJWD().toDocumentGeneral();
        case 'flattened-document':
          return this.toJWD().toDocumentFlattened();
        default:
          return this.toGeneral();
      }
    }
  }], [{
    key: 'decode',


    /**
     * decode
     *
     * @description
     * Decode a JSON Web Token
     *
     * @param {String} token
     * @returns {JWT}
     */
    value: function decode(token) {
      if (typeof token !== 'string') {
        throw new DataError('Invalid JWT');
      }

      // Parse
      if (token.startsWith('{')) {
        try {
          token = JSON.parse(token);
        } catch (err) {
          throw new DataError('Malformed JWT');
        }
      }

      // Compact
      if (typeof token === 'string') {
        return this.fromCompact(token);
      }

      // JSON General
      if (token.signatures || token.recipients) {
        return this.fromGeneral(token);

        // JSON Flattened
      } else {
        return this.fromFlattened(token);
      }
    }

    /**
     * fromCompact
     *
     * @description
     * Deserialize a Compact JWT and instantiate an instance
     *
     * @param  {String} data
     * @return {JWT}
     */

  }, {
    key: 'fromCompact',
    value: function fromCompact(data) {
      var ExtendedJWT = this;

      // Parse
      if (typeof data === 'string') {
        var segments = data.split('.');
        var protectedHeader = void 0;

        if (![3, 5].includes(segments.length)) {
          throw new DataError('Malformed JWT');
        }

        try {
          protectedHeader = JSON.parse(base64url.decode(segments[0]));
        } catch (err) {
          throw new DataError('Malformed JWT protected header');
        }

        // Sanity Check
        if ((typeof protectedHeader === 'undefined' ? 'undefined' : _typeof(protectedHeader)) !== 'object' || protectedHeader === null || Array.isArray(protectedHeader)) {
          throw new DataError('JWT Header must be an object');
        }

        // Decode base64url
        if (segments.length === 3) {
          var payload = void 0,
              signature = void 0;

          try {
            payload = JSON.parse(base64url.decode(segments[1]));
            signature = segments[2];
          } catch (err) {
            throw new DataError('Malformed JWS');
          }

          // Normalize and return instance
          return new ExtendedJWT(clean({
            payload: payload,
            signatures: [{ protected: protectedHeader, signature: signature }],
            serialization: 'compact',
            type: 'JWS'
          }));
        }

        if (segments.length === 5) {
          var encrypted_key = void 0,
              iv = void 0,
              ciphertext = void 0,
              tag = void 0;

          encrypted_key = segments[1];
          iv = segments[2];
          ciphertext = segments[3];
          tag = segments[4];

          return new ExtendedJWT(clean({
            protected: protectedHeader,
            iv: iv,
            ciphertext: ciphertext,
            tag: tag,
            recipients: [{ encrypted_key: encrypted_key }],
            serialization: 'compact',
            type: 'JWE'
          }));
        }
      }
    }

    /**
     * fromFlattened
     *
     * @description
     * Deserialize a JSON Flattened JWT and instantiate an instance
     *
     * @param  {Object|String} data
     * @return {JWT}
     */

  }, {
    key: 'fromFlattened',
    value: function fromFlattened(data) {
      var ExtendedJWT = this;

      // Parse
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          throw new DataError('Malformed JWT');
        }
      }

      // Input should be an object by now
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || data === null || Array.isArray(data)) {
        throw new DataError('Invalid JWT');
      }

      // decide if JWT is JWS(has payload) or JWE(has ciphertext)
      if (data.payload) {
        var protectedHeader = void 0,
            payload = void 0;

        // Decode base64url
        try {
          payload = JSON.parse(base64url.decode(data.payload));
          protectedHeader = JSON.parse(base64url.decode(data.protected));
        } catch (err) {
          throw new Error('Invalid JWT');
        }

        // Fetch decoded values
        var _data3 = data,
            unprotectedHeader = _data3.header,
            signature = _data3.signature;

        // Sanity Check

        if ((typeof protectedHeader === 'undefined' ? 'undefined' : _typeof(protectedHeader)) !== 'object' || protectedHeader === null || Array.isArray(protectedHeader)) {
          throw new DataError('JWT Protected Header must be an object');
        }

        if (unprotectedHeader && ((typeof unprotectedHeader === 'undefined' ? 'undefined' : _typeof(unprotectedHeader)) !== 'object' || unprotectedHeader === null || Array.isArray(unprotectedHeader))) {
          throw new DataError('JWT Unprotected Header must be an object');
        }

        // Normalize and return instance
        return new ExtendedJWT(clean({
          payload: payload,
          signatures: [{ protected: protectedHeader, header: unprotectedHeader, signature: signature }],
          serialization: 'flattened',
          type: 'JWS'
        }));
      } else {
        var _data4 = data,
            protect = _data4.protected,
            unprotect = _data4.unprotected,
            iv = _data4.iv,
            aad = _data4.aad,
            ciphertext = _data4.ciphertext,
            tag = _data4.tag,
            encrypted_key = _data4.encrypted_key,
            header = _data4.header;


        if (data.recipients) {
          throw new Error('Flattened JWE must not have recipients field');
        }

        try {
          if (protect) {
            protect = JSON.parse(base64url.decode(data.protected));
          }
        } catch (err) {
          throw new Error('Invalid JWT');
        }

        return new ExtendedJWT(clean({
          protected: protect,
          unprotected: unprotect,
          iv: iv,
          aad: aad,
          ciphertext: ciphertext,
          tag: tag,
          recipients: [{ header: header, encrypted_key: encrypted_key }],
          serialization: 'flattened',
          type: 'JWE'
        }));
      }
    }

    /**
     * fromGeneral
     *
     * @description
     * Deserialize a JSON General JWT and instantiate an instance
     *
     * @param  {Object|String} data
     * @return {JWT}
     */

  }, {
    key: 'fromGeneral',
    value: function fromGeneral(data) {
      var ExtendedJWT = this;

      // Parse
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          throw new DataError('Malformed JWT');
        }
      }

      // Input should be an object by now
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || data === null || Array.isArray(data)) {
        throw new DataError('Invalid JWT');
      }

      // decide if JWT is JWS(has payload) or JWE(has ciphertext)
      if (data.payload) {
        var payload = void 0,
            signatures = void 0;

        // Signatures must be present and an array
        if (!Array.isArray(data.signatures)) {
          throw new DataError('JWT signatures property must be an array');
        }

        // Decode payload
        try {
          payload = JSON.parse(base64url.decode(data.payload));
        } catch (err) {
          throw new Error('Invalid JWT');
        }

        // Decode signatures
        signatures = data.signatures.map(function (descriptor) {
          var protectedHeader = descriptor.protected,
              unprotectedHeader = descriptor.header,
              signature = descriptor.signature;

          var decodedHeader = void 0;

          try {
            decodedHeader = JSON.parse(base64url.decode(protectedHeader));
          } catch (err) {
            throw new DataError('Invalid JWT');
          }

          if (!decodedHeader || (typeof decodedHeader === 'undefined' ? 'undefined' : _typeof(decodedHeader)) !== 'object' || decodedHeader === null || Array.isArray(decodedHeader)) {
            throw new DataError('JWT Protected Header must be an object');
          }

          if (unprotectedHeader && ((typeof unprotectedHeader === 'undefined' ? 'undefined' : _typeof(unprotectedHeader)) !== 'object' || unprotectedHeader === null || Array.isArray(unprotectedHeader))) {
            throw new DataError('JWT Header must be an object');
          }

          return {
            protected: decodedHeader,
            header: unprotectedHeader,
            signature: signature
          };
        });

        // Normalize and return instance
        return new ExtendedJWT(clean({
          payload: payload,
          signatures: signatures,
          serialization: 'json',
          type: 'JWS'
        }));
      } else {
        var protect = void 0,
            unprotect = void 0,
            iv = void 0,
            aad = void 0,
            ciphertext = void 0,
            tag = void 0,
            recipients = void 0;

        try {
          if (data.protected) {
            protect = JSON.parse(base64url.decode(data.protected));
          }
        } catch (err) {
          throw new Error('Invalid JWT');
        }

        if (data.unprotected && (_typeof(data.unprotected) !== 'object' || data.unprotected === null || Array.isArray(data.unprotected))) {
          throw new DataError('JWE Unprotected Header must be an object');
        }
        unprotect = data.unprotected;
        iv = data.iv;
        aad = data.aad;
        if (!data.ciphertext) {
          throw new DataError("Ciphertext member not present");
        }
        ciphertext = data.ciphertext;
        tag = data.tag;

        if (!Array.isArray(data.recipients)) {
          throw new DataError('JWT recipients property must be an array');
        }

        recipients = data.recipients.map(function (descriptor) {
          var header = descriptor.header,
              encrypted_key = descriptor.encrypted_key;


          if (header && ((typeof header === 'undefined' ? 'undefined' : _typeof(header)) !== 'object' || header === null || Array.isArray(header))) {
            throw new DataError('JWE Header must be an object');
          }

          return {
            header: header,
            encrypted_key: encrypted_key
          };
        });

        return new ExtendedJWT(clean({
          protected: protect,
          unprotected: unprotect,
          iv: iv,
          aad: aad,
          ciphertext: ciphertext,
          tag: tag,
          recipients: recipients,
          serialization: 'json',
          type: 'JWE'
        }));
      }
    }

    /**
     * from
     *
     * @description
     * Instanciate a JWT from an object descriptor
     *
     * @param {Object|String} data
     * @param {String} [data.serialized] - Existing serialized JWT
     *
     * @return {JWT}
     */

  }, {
    key: 'from',
    value: function from(data) {
      var ExtendedJWT = this;

      // Decode serialized token
      if (typeof data === 'string' || data.serialized) {
        return this.decode(data.serialized || data);
      }

      if (data.ciphertext || data.plaintext) {
        var protect = data.protected,
            unprotected = data.unprotected,
            iv = data.iv,
            aad = data.aad,
            plaintext = data.plaintext,
            ciphertext = data.ciphertext,
            tag = data.tag,
            recipients = data.recipients,
            serialization = data.serialization,
            filter = data.filter;


        if (!plaintext && !ciphertext) {
          throw new DataError('Invalid JWT');
        }

        //filter the recipients
        if (recipients && Array.isArray(recipients)) {
          recipients = recipients.filter(function (descriptor) {
            return descriptor.encrypted_key;
          });
        } else {
          recipients = [];
        }

        // Normalize existing flat recipient
        if (data.encrypted_key) {
          var header = data.header,
              encrypted_key = data.encrypted_key;

          var descriptor = void 0;

          descriptor.header = header;
          descriptor.encrypted_key = encrypted_key;

          if (recipients && Array.isArray(recipients)) {
            recipients.unshift(descriptor);
          } else {
            recipients = [descriptor];
          }
        }
        return new ExtendedJWT(clean({
          protected: protect,
          unprotected: unprotected,
          iv: iv,
          aad: aad,
          plaintext: plaintext,
          ciphertext: ciphertext,
          tag: tag,
          recipients: recipients,
          serialization: serialization,
          type: 'JWE'
        }), {
          filter: filter || ExtendedJWT.name !== 'JWT' && ExtendedJWT.name !== 'JWD'
        });
      } else {
        var payload = data.payload,
            signatures = data.signatures,
            _serialization = data.serialization,
            _filter = data.filter;


        if (!payload) {
          throw new DataError('Invalid JWT');
        }

        // Include complete signature descriptors only
        if (signatures && Array.isArray(signatures)) {
          signatures = signatures.filter(function (descriptor) {
            return !descriptor.cryptoKey || descriptor.signature;
          });
        } else {
          signatures = [];
        }

        // Normalize existing flat signature
        if (!data.cryptoKey && data.signature) {
          var protectedHeader = data.protected,
              unprotectedHeader = data.header,
              signature = data.signature;

          var _descriptor = {};

          if (!protectedHeader && unprotectedHeader) {
            _descriptor.protected = unprotectedHeader;
          } else {
            _descriptor.protected = protectedHeader;
            _descriptor.header = unprotectedHeader;
          }

          _descriptor.signature = signature;

          if (signatures && Array.isArray(signatures)) {
            signatures.unshift(_descriptor);
          } else {
            signatures = [_descriptor];
          }
        }

        return new ExtendedJWT(clean({
          payload: payload,
          signatures: signatures,
          serialization: _serialization,
          type: 'JWS'
        }), {
          filter: _filter || ExtendedJWT.name !== 'JWT' && ExtendedJWT.name !== 'JWD'
        });
      }
    }

    /**
     * sign
     *
     * @description
     * Sign a JSON Web Token
     *
     * @params {...Object} data - Token data
     *
     * @returns {Promise<SerializedToken>}
     */

  }, {
    key: 'sign',
    value: function sign() {
      for (var _len6 = arguments.length, data = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        data[_key6] = arguments[_key6];
      }

      // Shallow merge data
      var params = Object.assign.apply(Object, [{}].concat(data));

      // Try decode
      var instance = void 0;
      try {
        instance = this.from(params);
      } catch (e) {
        return Promise.reject(e);
      }

      return instance.sign(params);
    }

    /**
     * encode
     *
     * @description
     * Encode a JSON Web Token
     *
     * @param {...Object} data
     *
     * @returns {Promise<SerializedToken>}
     */

  }, {
    key: 'encode',
    value: function encode() {
      for (var _len7 = arguments.length, data = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        data[_key7] = arguments[_key7];
      }

      // Shallow merge data
      var params = Object.assign.apply(Object, [{}].concat(data));

      // Try decode
      var instance = void 0;
      try {
        instance = this.from(params);
      } catch (e) {
        return Promise.reject(e);
      }

      return instance.encode(params);
    }

    /**
     * verify
     *
     * @description
     * Decode and verify a JSON Web Token
     *
     * @param {...Object} data
     * @returns {Promise<JWT>}
     */

  }, {
    key: 'verify',
    value: function verify() {
      for (var _len8 = arguments.length, data = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        data[_key8] = arguments[_key8];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));
      var serialized = params.serialized;


      if (!serialized) {
        throw new Error('JWT input required');
      }

      // Try decode
      var instance = void 0;
      try {
        instance = this.from(serialized);
      } catch (e) {
        return Promise.reject(e);
      }

      return instance.verify(params);
    }

    /**
     * encrypt
     *
     * @description
     * Encrypt the contents of a JSON Web Token
     *
     * @param {...Object} data
     * @returns {Promise<JWT>}
     */

  }, {
    key: 'encrypt',
    value: function encrypt() {
      for (var _len9 = arguments.length, data = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        data[_key9] = arguments[_key9];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));

      // Try decode
      var instance = void 0;
      try {
        instance = this.from(params);
      } catch (e) {
        return Promise.reject(e);
      }

      return instance.encrypt(params);
    }

    /**
     * decrypt
     *
     * @description
     * Decrypt the contents of a JSON Web Token
     *
     * @param {...Object} data
     * @returns {Promise<JWT>}
     */

  }, {
    key: 'decrypt',
    value: function decrypt() {
      for (var _len10 = arguments.length, data = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        data[_key10] = arguments[_key10];
      }

      var params = Object.assign.apply(Object, [{}].concat(data));
      var serialized = params.serialized;


      if (!serialized) {
        throw new Error('JWT input required');
      }

      // Try decode
      var instance = void 0;
      try {
        instance = this.from(serialized);
      } catch (e) {
        return Promise.reject(e);
      }

      return instance.decrypt(params);
    }
  }, {
    key: 'schema',
    get: function get() {
      return JWTSchema;
    }
  }]);

  return JWT;
}(JSONDocument);

/**
 * Export
 */


module.exports = JWT;


// WEBPACK FOOTER //
// ./lib/jose/JWT.js